
<main class="ks-card ks-bamboo-dialog">
  <header class="ks-card-header">
    <div class="ks-card-header__title ks-text-neutral ks-font-size-md ks-font-weight-medium">
      <span *ngIf="!bambooData?.riskScore?.picklist">NRX SCORES</span>
      <span *ngIf="bambooData?.riskScore?.picklist">Multiple Pateints Found</span>
    </div>
    <button type="button"
    ktTooltip="Close"
    class="ks-btn-xs ks-btn-icon-round ks-btn-flat-neutral"
            (click)="close()">
      <span inlineSVG="assets/icons/Close.svg"></span>
    </button>
  </header>

  <div class="ks-card-body">
    <div class="display-data" *ngIf="!bambooData?.riskScore?.picklist">
      <ng-container *ngIf="remainingNarxScores?.length; else noScores">

        <div *ngFor="let score of remainingNarxScores">
          <p class="ks-text-neutral ks-font-size-sm ks-font-weight-medium">
            {{ score.name }}
          </p>

          <p
            class="ks-font-size-lg ks-font-weight-bold"
            [ngClass]="score.color"
          >
            {{ score.value }}
          </p>

          <p class="ks-text-neutral ks-font-size-xs ks-font-weight-sm">
            Active.rx: {{ score.rx }}
          </p>
        </div>
      </ng-container>

    <ng-template #noScores>
        <div>X</div>
        <div>X</div>
        <div>X</div>
    </ng-template>
    </div>
    <div *ngIf="bambooData?.riskScore?.picklist === true" class="ks-text-warning ks-font-size-sm">
      {{bambooData?.riskScore?.picklistReason}}</div>
  </div>

  <div class="ks-card-footer ks-d-flex ks-flex-dir-column ks-pt-0">
    <div class="ks-d-flex ks-flex-dir-column ks-border-bottom-regular-solid ks-border-light-neutral ks-mb-3">
    <button
        *ngIf="bambooData?.riskScore.viewableReportUrl"
        class="ks-btn-sm ks-btn-flat-secondary bg-transparent"
              style="justify-content:flex-start"
      (click)="showNarxCareReport()"
      [disabled]="reportTriggered">
        <span inlineSVG="assets/icons/chart-line-up.svg"
              class="svg-icon svg-icon-md svg-icon-secondary ks-mr-3"></span>
        <span> Click to open full NarxCare </span>
      </button>
    <button *ngIf = "!isSkipped || bambooData?.code !== 422"
      class="ks-btn-sm ks-btn-flat-neutral bg-transparent"
            style=" justify-content:flex-start"
    (click)="RefreshScore()">
      <span inlineSVG="assets/icons/History.svg"
            class="svg-icon svg-icon-md svg-icon-neutral ks-mr-3"></span>
      <span>Refresh score </span>
    </button>
    </div>
    <div class="ks-text-dark-warning ks-bg-lighter-warning ks-font-size-xs ks-border-regular-solid
    ks-border-warning ks-border-radius-md ks-p-3">
      <span inlineSVG="assets/icons/Warning-label.svg"></span>
      Intended to aid, not replace, medical decision-making.
      None of the information presented should be used as sole justification
      for providing or refusing to provide medications.
    </div>
    <div *ngIf="bambooData?.riskScore.disclaimer"
         class="ks-text-warning ks-pt-3 ks-font-size-sm ks-d-flex ks-flex-dir-column">
      <span class="ks-font-weight-medium ks-text-darker-warning">DISCLAIMER: </span>
      {{bambooData?.riskScore.disclaimer}}
    </div>
  </div>

</main>

